<ng-container *ngIf="shouldShow">
  <div class="sky-card mt highlight-attention">
    <div class="sky-card-header">
      <h2 class="h3 mb-0">Wishlist</h2>
    </div>
    <div class="sky-card-body">
      <div class="container">
        Limited items you have favourited are available right now!
      </div>
      <div class="sky-flex flex-wrap mt">
        <ng-container *ngFor="let item of items">
          <ng-container *ngIf="ongoingItems[item.guid]">
            <a class="wishlist-item" [ngbTooltip]="item.name" container="body" [routerLink]="itemLinks[item.guid]?.route" [queryParams]="itemLinks[item.guid]?.extras?.queryParams">
              <app-item-icon [item]="item" [opaque]="true" [hoverGlow]="false" [showSubIcons]="true"></app-item-icon>
            </a>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
